{
  "id": "campaign-076",
  "name": "Quiet Links II",
  "seed": "campaign:76",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........,._.",
    "....ooos,._.",
    "..q.oFoss._.",
    "*...ooo..._*",
    "*.ssW..W.._*",
    "*.s......._*",
    "*........._*",
    "*.h.W..W.h_*",
    ".........._x",
    ".q........_.",
    "....W..W.._.",
    ".........._.",
    "....T..T.._.",
    "..~~..x..._.",
    "...~......_.",
    "..b....x.b_.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 3,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 5
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "rare",
      "x": 2,
      "y": 13
    },
    {
      "kind": "repair",
      "x": 3,
      "y": 7
    }
  ],
  "generatorVersion": 3,
  "level": 76,
  "biome": "golf",
  "par": {
    "reel": 6407,
    "push": 5578,
    "selfPropelled": 5160,
    "tractor": 4870,
    "zeroTurn": 3631,
    "fairway": 2437
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 7,
      "selfPropelled": 14,
      "tractor": 0,
      "zeroTurn": 12,
      "fairway": 19
    }
  }
}
